import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  ApiService,
  IDeliveryCheckInfo,
  IProductType, IProductTypeOverview,
  isPiecesOrPiecesGroup, IUpsellProductType,
  TransferableGetApiService
} from '@cakeiteasy/web-utils';
import moment from 'moment';
import { Observable } from 'rxjs';
import { TransferState } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable()
export class ProductsApiService extends TransferableGetApiService {
  constructor(@Inject('AppConfig') appConfig: any,
              @Inject(PLATFORM_ID) _platformId: any,
              api: ApiService,
              transferState: TransferState) {
    super(api, appConfig, _platformId, transferState);
  }

  public getCakes(params): Observable<IProductTypeOverview[]> {
    if (this.appConfig.cakesCategoryId) {
      Object.assign(params, { categoryId: this.appConfig.cakesCategoryId });
    }

    return this.getWithCaching('api.products', 'product_types', {},
      { params: { ...params, newSearch: true } })
      .pipe(
        map((productTypes) => {
          productTypes.forEach((pt) => {
            pt.pieces = isPiecesOrPiecesGroup(pt.structureType);
            // TODO remove if mail delivery become available NS3-3070
            pt.mailDeliveryAvailable = false;
          });

          return productTypes;
        })
      );
  }

  public getFilters(params): Promise<any> {
    if (this.appConfig.cakesCategoryId) {
      Object.assign(params, { categoryId: this.appConfig.cakesCategoryId });
    }

    return this.getWithCaching('api.products', 'product_types_filters', {}, { params })
      .toPromise();
  }

  public getProductType(productTypeId: number): Promise<IProductType> {
    return this.getWithCaching('api.products', 'product_types_one', { id: productTypeId })
      .toPromise()
      .then((productType) => {
        productType.sizes = productType.sizes.filter((size) => size.products.length > 0);

        productType.pieces = isPiecesOrPiecesGroup(productType.structureType);

        return productType;
      });
  }

  public getProductTypeUpsellProducts(productTypeId: number, params?: any): Promise<IUpsellProductType[]> {
    return this.getWithCaching('api.products', 'product_types_upsell_products_one', { id: productTypeId }, { params })
      .toPromise();
  }

  public getProductTypeDeliverDate(productTypeId: number, date: Date): Promise<IDeliveryCheckInfo> {
    let utcDate = moment(date).format('YYYY-MM-DD');
    return this.api
      .get('api.products', 'product_types_one_closest_delivery_date',
        {
          id: productTypeId
        }, {
          params: {
            deliveryDate: utcDate
          }
        })
      .toPromise()
      .then((res) => {
        let jsDate = moment(res.date).toDate();
        if (res.date === utcDate) {
          return res;
        } else {
          return { ...res, closestDate: jsDate, date: null };
        }
      })
      .catch(() => {
        return {
          date: null,
          closestDate: null,
          outletExists: false,
          deliveryPointExists: false
        };
      });
  }
}
